import { RouteRecordRaw } from 'vue-router';

export const forcedIdeationRouteConfig: RouteRecordRaw = {
  name: 'forcedIdeation',
  path: '/forced-ideation',
  component: () => import('@/components/forced-ideation/layouts/main.vue'),
  meta: { accessScope: 'forced_ideation' },
  redirect: { name: 'forcedIdeationNew' },
  children: [
    {
      path: '/forced-ideation/new',
      component: () =>
        import('@/components/forced-ideation/forced-ideation-new.vue'),
      name: 'forcedIdeationNew',
      meta: { title: 'アイデアを作成' },
    },
    {
      // detail（/forced-ideation/:uuid）より先に置く（draft を uuid として捕まえないため）
      path: '/forced-ideation/draft/:uuid',
      component: () =>
        import('@/components/forced-ideation/forced-ideation-draft.vue'),
      name: 'forcedIdeationDraft',
      props: true,
      meta: { title: '下書きを編集' },
    },
    {
      path: '/forced-ideation/:uuid',
      component: () =>
        import('@/components/forced-ideation/forced-ideation-detail.vue'),
      name: 'forcedIdeationDetail',
      props: true,
      meta: { title: 'アイデア詳細' },
    },
  ],
};
